/**
 * Mixin for common Findify page tracking.
 * Used on all pages except the PDP, which use a custom version.
 */

export default {
  methods: {
    findify_trackPageView () {
      this.$findifyAnalytics().sendEvent('view-page', {
        url: window.document.URL,
        ref: window.document.referrer,
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
  }
}
